<article>
  <table mat-table [dataSource]="channels()" class="mat-table-container">
    <ng-container matColumnDef="mediaType">
      <th mat-header-cell *matHeaderCellDef>Media</th>
      <td mat-cell *matCellDef="let element">
        {{ element.mediaType | mediaType }}
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nom du support</th>
      <td mat-cell *matCellDef="let element">{{ element.name || '-' }}</td>
    </ng-container>
    <ng-container matColumnDef="totalExpenses">
      <th mat-header-cell *matHeaderCellDef>Dépenses générales (FCFA)</th>
      <td mat-cell *matCellDef="let element">
        {{ element.totalExpenses || '-' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
